<h2 mat-dialog-title>Informacion</h2>
<div mat-dialog-content>
    <p>{{data.mensaje}}</p>
    <br *ngIf="data.mensaje_negrita.length>0">
    <p *ngIf="data.mensaje_negrita.length>0"><b>{{data.mensaje_negrita}}</b></p>
</div>

<div mat-dialog-actions class="justify-content-center">
    <button mdbBtn type="button" color="blue" (click)="confirmado()" outline="true" mdbWavesEffect>Ok</button>
    <!--
<button mdbBtn type="button" color="deep-purple" (click)="cerrarDialogo()" outline="true" mdbWavesEffect>No</button>
    -->

</div>

